var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentsGraphic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.78,
    y: 23.08,
    width: 240.93,
    height: 300.66,
    style: {
      fill: "#ebf2f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.23,259.75c0,8.21-36.12,14.88-80.67,14.88S67.9,268,67.9,259.75s36.11-14.88,80.66-14.88S229.23,251.53,229.23,259.75Z",
    style: {
      fill: "#d9e5f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.22,244.87c0,8.21-36.11,14.88-80.66,14.88s-80.67-6.67-80.67-14.88S175,230,219.56,230,300.22,236.65,300.22,244.87Z",
    style: {
      fill: "#d9e5f4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.1 201.51 266.1 72.19 144.46 72.19 144.46 233.66 237.2 233.66 266.1 201.51",
    style: {
      fill: "#d4d4d3",
      stroke: "#c6c6c5",
      strokeMiterlimit: 10,
      strokeWidth: "4.524088107204438px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.63,
    y: 83.43,
    width: 100.13,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.63,
    y: 91.99,
    width: 100.13,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.63,
    y: 100.55,
    width: 100.13,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.63,
    y: 109.1,
    width: 100.13,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.63,
    y: 117.66,
    width: 100.13,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.63,
    y: 126.22,
    width: 100.13,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.59,
    y: 136.89,
    width: 54.87,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.59,
    y: 145.45,
    width: 54.87,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.59,
    y: 154,
    width: 54.87,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.59,
    y: 162.56,
    width: 54.87,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.59,
    y: 171.12,
    width: 54.87,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.63,
    y: 139.97,
    width: 41.45,
    height: 37.3,
    style: {
      fill: "#00b0c2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.74,
    y: 186.09,
    width: 44.88,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.74,
    y: 194.65,
    width: 44.88,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.74,
    y: 203.2,
    width: 44.88,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.74,
    y: 211.76,
    width: 44.88,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.74,
    y: 220.32,
    width: 44.88,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.77,
    y: 186.09,
    width: 41.44,
    height: 37.3,
    style: {
      fill: "#00b0c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.2,233.66l28.9-32.15s-4.28-15.9-28.9-19.54C237.2,182,252.41,208.6,237.2,233.66Z",
    style: {
      fill: "#929191"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.6 216.21 293.6 86.89 171.95 86.89 171.95 248.35 264.69 248.35 293.6 216.21",
    style: {
      fill: "#fff",
      stroke: "#c6c6c5",
      strokeMiterlimit: 10,
      strokeWidth: "4.524088107204438px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.12,
    y: 98.12,
    width: 100.13,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.12,
    y: 106.68,
    width: 100.13,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.12,
    y: 115.24,
    width: 100.13,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.12,
    y: 123.8,
    width: 100.13,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.12,
    y: 132.36,
    width: 100.13,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.12,
    y: 140.91,
    width: 100.13,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.08,
    y: 151.58,
    width: 54.87,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.08,
    y: 160.14,
    width: 54.87,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.08,
    y: 168.7,
    width: 54.87,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.08,
    y: 177.25,
    width: 54.87,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.08,
    y: 185.81,
    width: 54.87,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.12,
    y: 154.66,
    width: 41.45,
    height: 37.3,
    style: {
      fill: "#e56b63"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.23,
    y: 200.78,
    width: 44.88,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.23,
    y: 209.34,
    width: 44.88,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.23,
    y: 217.9,
    width: 44.88,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.23,
    y: 226.45,
    width: 44.88,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.23,
    y: 235.01,
    width: 44.88,
    height: 2.7,
    style: {
      fill: "#c6c6c5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.27,
    y: 200.78,
    width: 41.45,
    height: 37.3,
    style: {
      fill: "#e56b63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.69,248.35l28.91-32.14s-4.29-15.91-28.91-19.54C264.69,196.67,279.9,223.29,264.69,248.35Z",
    style: {
      fill: "#929191"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.25 260.14 84.77 259.79 96.6 162.71 224.07 163.07 212.25 260.14",
    style: {
      fill: "#9e7521"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.96,
    y: 155.17,
    width: 93.83,
    height: 115.76,
    transform: "translate(-64.59 361.34) rotate(-89.84)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.88 172.92 131.9 162.81 85.04 162.68 85.01 172.79 84.99 179.56 84.77 259.79 212.25 260.14 212.49 173.14 131.88 172.92",
    style: {
      fill: "#f8b133"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.51,173.08a97.57,97.57,0,0,1-12.14,15.07C157.73,206,133.56,214.5,109,217.25a152.63,152.63,0,0,1-24.16.87l-.11,41.67,127.48.36.24-87Z",
    style: {
      fill: "#f5f5f5",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.88,172.06l0-9.25h-.08a72.67,72.67,0,0,0,0,8.35C131.83,171.46,131.86,171.76,131.88,172.06Z",
    style: {
      fill: "#d9d9d9",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.75,240.19c-18-5.13-34.21-17-42.88-33.82a84.42,84.42,0,0,1-9.41-41.81c0-.6.06-1.21.09-1.82L85,162.68l-.27,97.11,127.48.36.06-22.35C195.16,244,176.21,245.18,158.75,240.19Z",
    style: {
      fill: "#d9d9d9",
      mixBlendMode: "multiply"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsGraphic);
export default __webpack_public_path__ + "static/media/documents_graphic.e1c3c17985e8494666c906b1540d8f23.svg";
export { ForwardRef as ReactComponent };